import { Button } from '@progress/kendo-react-buttons';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React, { useState } from 'react';
import { CpsGridCell } from './CpsGridCell';
import { hyperlinkOpenIcon, clockArrowRotateIcon } from '@progress/kendo-svg-icons';
import { DocumentVersionViewer } from '../documentVersionViewer';
import { useCurrentUserContext } from '@cs-cms/state-management';
import { EMPTY_VALUE } from '@cs-cms/types';

interface LinkedCellProps extends GridCustomCellProps {
  onLinkClicked: () => void;
  title?: string;
  value?: string;
  documentId?: string;
  documentName?: string;
  contentType?: string;
}

export const LinkedCell: React.FC<LinkedCellProps> = props => {
  const { selectedIndex } = useCurrentUserContext();
  const [isVersionViewerOpen, setIsVersionViewerOpen] = useState(false);
  const field = props.field || EMPTY_VALUE;
  const value = props.value || props.dataItem[field];
  const title = props.title || value?.toString();

  const handleOpenVersionViewer = () => {
    setIsVersionViewerOpen(true);
  };

  const handleCloseVersionViewer = () => {
    setIsVersionViewerOpen(false);
  };

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={title}
    >
      <div className="linkedCell">
        <Button
          svgIcon={hyperlinkOpenIcon}
          title={value?.toString()}
          size="small"
          fillMode="link"
          onClick={props.onLinkClicked}
        >
          {value?.toString() || EMPTY_VALUE}
        </Button>
        {selectedIndex?.supportsVersioning && props.documentId && props.documentName && props.contentType && (
          <Button
            svgIcon={clockArrowRotateIcon}
            title="Open version history"
            size="small"
            fillMode="link"
            onClick={handleOpenVersionViewer}
          />
        )}
      </div>

      {selectedIndex?.supportsVersioning && props.documentId && props.documentName && props.contentType && (
        <DocumentVersionViewer
          isOpen={isVersionViewerOpen}
          onClose={handleCloseVersionViewer}
          documentId={props.documentId}
          documentName={props.documentName}
          contentType={props.contentType}
        />
      )}
    </CpsGridCell>
  );
};
